import api from 'api/apiInstance';

export function clientFinancialStrategyMarkAsSeenApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
